fragment ContactDuplicateFragment on Contact {
    id
    hasDuplicates
}
